import { MessagingSdk } from 'lib-klab-sdks';

export interface MessageReactionGroup {
  emoji: string;
  count: number;
  userIds: number[];
  reactedByCurrentUser: boolean;
}

/** Groups raw reaction identities without maintaining a second count-based state. */
export function groupMessageReactions(
  reactions: readonly MessagingSdk.MessageReaction[] | null | undefined,
  currentUserId: number,
): MessageReactionGroup[] {
  const identitiesByEmoji = new Map<string, Set<number>>();
  for (const reaction of reactions ?? []) {
    if (!reaction || typeof reaction.emoji !== 'string' || !Number.isFinite(reaction.userId)) continue;
    const identities = identitiesByEmoji.get(reaction.emoji) ?? new Set<number>();
    identities.add(reaction.userId);
    identitiesByEmoji.set(reaction.emoji, identities);
  }

  return Array.from(identitiesByEmoji, ([emoji, identities]) => {
    const userIds = Array.from(identities).sort((left, right) => left - right);
    return {
      emoji,
      count: userIds.length,
      userIds,
      reactedByCurrentUser: userIds.includes(currentUserId),
    };
  }).sort((left, right) => (left.emoji < right.emoji ? -1 : left.emoji > right.emoji ? 1 : 0));
}
